export const API_KEY_LOADING = 'API_KEY_LOADING';
export const API_KEY_LOADED = 'API_KEY_LOADED';
